export default {"src":"/_next/static/media/coverImage.47514a1b.svg","height":668,"width":699};